<template>
  <section class="content">
    <bulk-update-modal :branches="filteredStores" :storeCount="storeCount" :companyId="$route.params.id" @loadBulkUpdate="updateBulkStoreMp($event)"></bulk-update-modal>
    <div class="modal fade" id="new-user" tabindex="-1" role="dialog" style="display: none;" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" id="closeUserModal" @click="reset()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title">{{'add_modify_user' | translate}}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'username' | translate}}*</label>
                <input :disabled="!newUser" v-validate="'required'" data-vv-as="'username'" class="form-control" name="username" :placeholder="'username' | translate" type="text" v-model="selectedUser.username">
                <span v-show="errors.has('username')" class="small text-danger">{{ errors.first('username') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'password' | translate}}</label>
                <input :disabled="newUser" class="form-control" :placeholder="'password' | translate" :type="showPassword ? 'text' : 'password'" v-model="selectedUser.password">
                <input type="checkbox" v-model="showPassword"><span class="text-muted"> Show password?</span>
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6 col-xs-12">
                <label class="pull-left">{{'first_name' | translate}}</label>
                <input class="form-control" :placeholder="'first_name' | translate" type="text" v-model="selectedUser.first_name">
              </div>
              <div class="form-group col-sm-6 col-xs-12">
                <label class="pull-left">{{'last_name' | translate}}</label>
                <input class="form-control" :placeholder="'last_name' | translate" type="text" v-model="selectedUser.last_name">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xs-12">
                <fieldset>
                  <legend style="color: white">{{'roles' | translate}}:</legend>
                  <input type="checkbox" name="roles" value="co_admin" v-model="selectedUser.roles"><span class="ml-5">{{'co_admin' | translate}}</span><br>
                  <input type="checkbox" name="roles" value="co_orders" v-model="selectedUser.roles"><span class="ml-5">{{'co_orders' | translate}}</span><br>
                  <input type="checkbox" name="roles" value="co_orders_send" v-model="selectedUser.roles"><span class="ml-5">{{'co_orders_send' | translate}}</span><br>
                  <input type="checkbox" name="roles" value="co_products" v-model="selectedUser.roles"><span class="ml-5">{{'co_products' | translate}}</span><br>
                  <br>
                </fieldset>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'email' | translate}}*</label>
                <input v-validate="'required|email'" data-vv-as="'email'" class="form-control" name="email" placeholder="Email" type="text" v-model="selectedUser.email">
                <span v-show="errors.has('email')" class="small text-danger">{{ errors.first('email') }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModal" @click="reset()" class="btn btn-app btn-outline no-margin pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate($parent.$store.getters.language)}}</button>
            <button type="button" :disabled="errors.any()" class="btn btn-app btn-success no-margin" @click="send()"><span class="fa fa-save "></span>{{'submit' | translate($parent.$store.getters.language)}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--<template v-if="loading">
      <div class="row">
        <div class="col-xs-12 text-center">
          <img class="loading-gif" src="/static/img/blabla.svg"/>
        </div>
      </div>
    </template>-->
    <template>
      <div class="row" v-if="newCompany">
        <create-company :company="company" @alert="alert($event)" @trigger="loading = !loading"></create-company>
      </div>
      <div class="row" v-else>
        <edit-company @update="update($event)" :company="company" @alert="alert($event)" :fullLoading="loading"></edit-company>
        <stores-table :loading="childLoading" :pagination="storePagination" :storeData="storeData" :id="$route.params.id" @storeBulkUpdate="updateFilteredStores($event)" @loadingSingleUpdate="updateSingleStoreMp($event)"></stores-table>
        <users-table :pagination="users" :id="$route.params.id" :loading="loadingUsers" @selectUser="edit"></users-table>
      </div>
      <div class="row" v-if="!newCompany"></div>
    </template>
    <div class="overlay" v-show="loading">
      <img class="loading-gif-major" src="/static/img/blabla.svg"/>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        childLoading: false,
        loadingUsers: false,
        loading: false,
        newCompany: false,
        showPassword: false,
        newUser: false,
        storeCount: 0,
        filteredStores: {},
        reload: false,
        roles: ['co_dashboard', 'co_orders', 'co_products', 'co_marketplace', 'co_import_configuration', 'co_accounting'],
        users: {
	        total: 0,
	        per_page: 25,
	        current_page: 1,
	        total_pages: 0
        },
        selectedUser: {
        	first_name: '',
          last_name: '',
          email: '',
          password: '',
          roles: ['co_dashboard', 'co_accounting']
        },
        company: {
          name: '',
          erp_system_id: '',
          organisation_number: '',
          inv_email: '',
          inv_company: '',
          inv_first_name: '',
          inv_last_name: '',
          inv_street: '',
          inv_postcode: '',
          inv_city: '',
          qb_email: '',
          shipcloud_key: ''
        },
        alerts: [],
        storeData: {},
        marketplaces: {},
        storePagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0
        },
      }
    },
    methods: {
      updateBulkStoreMp (data) {
        this.childLoading = true
        for (let storeId in data.stores) {
          API.put(`accounting/companies/${this.$route.params.id}/stores/mp`, {store_id: data.stores[storeId].id, channels: data.bulkChannels})
            .then(response => {
              API.get(`/statistics/stores/details?company_id=${this.$route.params.id}`)
                .then(response => {
                  this.prepareMarketplaceData(response.data)
                  this.childLoading = false
                })
                .catch(error => {
                  console.log(error.response)
                })
            })
        }
      },
      updateSingleStoreMp (eventData) {
        this.childLoading = true
        API.put(`accounting/companies/${this.$route.params.id}/stores/mp`, {"store_id": eventData.storeInfo.id,"channels": {[eventData.dataInfo.name]: eventData.dataInfo.active}})
        .then(response => {
          API.get(`/statistics/stores/details?company_id=${this.$route.params.id}`)
            .then(response => {
              this.prepareMarketplaceData(response.data)
              this.childLoading = false
            })
            .catch(error => {
              console.log(error.response)
            })
        })
      },
      edit (data) {
        this.selectedUser = data
      },
      updateFilteredStores () {
        this.storeCount = this.storePagination.length
        this.filteredStores = this.storePagination
      },
      alert (value) {
        let message, icon
        switch (value) {
          case 'error':
            message = 'Some fields are still incorrect'
            icon = 'icon fa fa-warning'
            value = 'warning'
            break
          case 'error-unknown':
            message = 'Something went wrong'
            icon = 'icon fa fa-warning'
            value = 'danger'
            break
          case 'success':
            message = 'Successfully created company'
            icon = 'icon fa fa-check'
            break
          case 'ext':
            message = 'Successfully created/updated extension'
            icon = 'icon fa fa-check'
            value = 'success'
            break
          case 'config-post':
            message = 'Successfully created configuration'
            icon = 'icon fa fa-check'
            value = 'success'
            break
          case 'config-put':
            message = 'Successfully updated configuration'
            icon = 'icon fa fa-check'
            value = 'success'
            break
        }
        let alert = {
          type: value,
          dismiss: 4,
          message: message,
          icon: icon,
          show: true
        }
        this.$store.commit('pushAlert', alert)
      },
      update (data) {
        this.loading = true
        API.put(`accounting/companies/${this.company.id}`, data)
          .then(value => {
            let alert
            if (value.status === 200 || value.status === 204) {
              alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
            } else if (value.status === 0) {
              alert = {dismiss: 4, type: 'warning', message: 'Not modified. Company Already Exists', icon: 'icon fa fa-warning', show: true}
            } else {
              alert = {dismiss: 4, type: 'danger', message: `There was an error: ${value.body.message}`, icon: 'icon fa fa-ban', show: true}
            }
            this.$store.commit('pushAlert', alert)
            API.get(`accounting/companies/${this.$route.params.id}`)
              .then(response => {
                this.loading = false
                this.company = response.data
              })
              .catch(error => {
                let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
                this.$store.commit('pushAlert', alert)
              })
          })
          .catch(error => { this.$emit('update', 'error') })
      },
      reset () {
        this.newUser = false
      	this.selectedUser = {
		      first_name: '',
		      last_name: '',
		      email: '',
		      password: '',
		      roles: ['co_dashboard', 'co_accounting']
	      }
	      this.$validator.reset()
      },
      send () {
        this.loadingUsers = true
      	this.$validator.validate()
          .then(result => {
          	if(result) {
              this.selectedUser.roles = [...new Set(this.selectedUser.roles.concat(['co_accounting', 'co_dashboard']))]
          		let url = `accounting/companies/${this.$route.params.id}/users`
          		if(this.newUser) {
          			API.post(url, this.selectedUser)
                  .then(result => {
                  	this.newUser = false
                    this.reset()
                    this.getUsers()
                  	$('#closeUserModal').click()
                    this.loadingUsers = false
                  })
                  .catch(error => {
	                  this.newUser = false
	                  this.reset()
                    this.getUsers()
	                  $('#closeUserModal').click()
                    this.loadingUsers = false
                  })
              } else {
          			API.put(`${url}/${this.selectedUser.id}`, this.selectedUser)
                  .then(result => {
	                  this.reset()
                    this.getUsers()
	                  $('#closeUserModal').click()
                    this.loadingUsers = false
                  })
                  .catch(error => {
                  	this.reset()
                    this.getUsers()
	                  $('#closeUserModal').click()
                    this.loadingUsers = false
                  })
              }
            }
          })
      },
      getUsers () {
	      API.get(`accounting/companies/${this.$route.params.id}/users`, {})
		      .then(response => {
			      this.users = response.data
		      })
		      .catch(error => {
			      console.log(error.response)
		      })
      },
      customLabel ({label}) {
        return `${this.$options.filters.translate(label, this.$store.getters.language)}`
      },
      check (e) {
        if(e.keyCode !== 8 && e.keyCode < 37 || e.keyCode > 40) {
          e.preventDefault()
        }
      },
      buildString (option, id) {
        if (!this.errors.any() && option.label !== '') {
          this.company.barcode_content += id === 0? this.company.barcode_content.length === 0 ? option.label : `-${option.label}` : this.company.barcode_content.length === 0 ? `#${option.label}#` : `-#${option.label}#`
        }
      },
      postData () {
        API.put(`accounting/companies/${this.$route.params.id}`, this.company)
          .then(response => {
            this.$emit('update', response)
          })
          .catch(error => {
            this.$emit('update', 'error')
          })
      },
      prepareMarketplaceData (data) {
        for (let channels in data) {
          this.marketplaces[data[channels].store_number] = data[channels]
        }
        this.storeData = this.marketplaces
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$route.params.id !== 'new') {
          this.getUsers()
          this.childLoading = true
          API.get(`accounting/companies/${this.$route.params.id}`)
            .then(response => {
              this.company = response.data
              API.get(`accounting/companies/${this.$route.params.id}/stores`)
                .then(response => {
                  this.storePagination = response.data
                  API.get(`/statistics/stores/details?company_id=${this.$route.params.id}`)
                    .then(response => {
                      this.prepareMarketplaceData(response.data)
                      this.updateFilteredStores()
                      this.childLoading = false
                    })
                    .catch(error => {
                      console.log(error.response)
                      this.childLoading = false
                    })
                })
                .catch(error => {
                  console.log(error.response)
                  this.childLoading = false
                })
            })
            .catch(error => {
              this.alerts.push({dismiss: 4, type: 'danger', message: `There was an error: ${error.body.message}`, icon: 'icon fa fa-ban', show: true})
              this.childLoading = false
            })
        } else {
          this.newCompany = true
        }
      })
    },
    watch: {
      '$route' () {
        if (this.$route.params.id !== 'new') {
          this.newCompany = false
          API.get(`accounting/companies/${this.$route.params.id}`)
            .then(response => {
              this.company = response.data
            })
            .catch(error => {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
              //this.alerts.push(alert)
            })
        } else {
          this.newCompany = true
        }
      }
    }
  }
</script>
<style scoped>
  .loading-gif-major {
    margin-left: 47%;
    margin-top: 15%;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Company.vue